import * as React from 'react';

export function SvgZap(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.398 3.083a1 1 0 01.594 1.041l-.66 5.276H19.4a1 1 0 01.768 1.64l-8 9.6a1 1 0 01-1.76-.764l.66-5.276H5a1 1 0 01-.768-1.64l8-9.6a1 1 0 011.166-.277z"
        fill="currentColor"
      />
    </svg>
  );
}
